import { render, staticRenderFns } from "./NoOfferNotifier.vue?vue&type=template&id=216818d2&scoped=true"
import script from "./NoOfferNotifier.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoOfferNotifier.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NoOfferNotifier.vue?vue&type=style&index=0&id=216818d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216818d2",
  null
  
)

export default component.exports